import { type FC } from 'react'

import './_liveActions.scss'
import { useTranslation } from 'react-i18next'

import placeholderAvatar from 'assets/images/user_placeholder.png'
import { IconActionTip, IconChatOutline, IconLiveCircleTip } from 'assets/svg/sprite'

interface Props {
  role: 'creator' | 'viewer'
  openTipModal: () => void
  toggleComments: () => void
  avatarUrl?: string | null | undefined
  commentCount?: number
  startModalOpen?: boolean
}

const LiveActions: FC<Props> = ({ openTipModal, toggleComments, role, avatarUrl, commentCount, startModalOpen }) => {
  const { t } = useTranslation()

  return (
    <div className={`liveActions liveActions__${role}`}>
      <div className='liveActions__avatar'>
        <div className='liveActions__avatar--ring'>
          <img src={avatarUrl ?? placeholderAvatar} alt='avatar' />
        </div>
      </div>

      {role === 'creator' && (
        <div className='liveAction' onClick={openTipModal}>
          <IconActionTip />
          {/* <span>Set</span> */}
        </div>
      )}

      <div
        className={`liveAction ${startModalOpen ? 'disabled' : ''}`}
        onClick={startModalOpen ? undefined : toggleComments}
      >
        <IconChatOutline />
        <span>{typeof commentCount === 'number' ? commentCount : 50}</span>
      </div>

      {role === 'viewer' && (
        <div className='liveAction liveAction__viewer' onClick={openTipModal}>
          <IconLiveCircleTip />
          <span>{t('tip')}</span>
        </div>
      )}
    </div>
  )
}

export default LiveActions
